<div class="ticket" [class.expanded]="isExpanded" [ngClass]="{ 'pending-ticket': ticket.get('status') === 'Pending' }">
  <div *ngIf="!allocationView" class="flex justifySB alignFS">
    <div class="col-xs-11">
      <div data-testid="ticket-header" class="ticket-header">
        <div class="flex justifySB w100">
          <h4 data-testid="ticket-title" [ngStyle]="isExpanded ? {'display': 'none'} : {}">
            <b class="fw-700">Title:</b> {{ticket?.get('title') || ticket?.get('titleLanguageString')?.get('en')}}
            <span data-testid="ticket-number" class="fontS">({{ticket.get('ticketNumber')}})</span> 
          </h4>
          <span *ngIf="canBeCaptured()">
            <button class="btn btn-xs btn-primary" (click)="captureTicket()">Capture</button>
          </span>
          <div [ngStyle]="isExpanded ? {'display': 'none'} : {}" class="discomfort-tag" *ngIf="ticket?.get('operatorAnalysisResponse')?.category === 'discomfort' || (ticket?.get('llmResponse')?.category== 'discomfort' && ticket?.get('operatorAnalysisResponse')?.category === undefined)">Discomfort</div>
          <div [ngStyle]="isExpanded ? {'display': 'none'} : {}" class="discomfort-tag" *ngIf="ticket?.get('operatorAnalysisResponse')?.subcategory === 'dissatisfaction related' || (ticket?.get('llmResponse')?.subcategory== 'dissatisfaction related' && ticket?.get('operatorAnalysisResponse')?.subcategory === undefined)">Dissatisfaction</div>
          <div class="flex alignC gap-12" *ngIf="!isExpanded">
            <div class="duplicate-checkbox" *ngIf="showDuplicateCheckbox">
              <input type="checkbox" 
                    [checked]="isSelected" 
                    (change)="onSelectionChangeHandler($event)"
                    [disabled]="!isDuplicateCheckboxEnabled"
                    class="duplicate-checkbox-input"
                    data-testid="ticket-duplicate">
              <span class="checkmark"></span>
            </div>
            <div class="bold" *ngIf="userRoles.includes('adminDoctor')" class="fa fa-user-circle-o fw-700 fontL3 icon-color" (click)="switchToAlloactionView()"></div>
          </div>
        </div>
        <div *ngIf="!isExpanded" class="w100 flex flex-dir-col alignFS">
          <p style="margin-bottom: 5px;"><b>Created by:</b> {{ ticket?.get('createdBy')?.get('username')}} ({{ticket.get('createdAt') | date:'dd MMM yyyy HH:mm'}}) </p>
          <p style="margin-bottom: 5px;"><b>Status:</b> {{ ticket?.get('status') }}
            <span *ngIf="ticket?.get('status') === 'Completed'">({{ticket.get('completedAt') | date:'dd MMM yyyy HH:mm'}}) </span> 
          <p *ngIf="ticket?.get('status') === 'Completed'" style="margin-bottom: 5px;"><b>Completed by:</b> {{ ticket?.get('completedBy')?.get('username')}} </p>
          <p *ngIf="ticket?.get('teams')?.length > 0" style="margin-bottom: 5px;"><b>Assigned Team:</b> {{ ticket?.get('teams')[0]}} <span *ngIf="allocatedTo">({{allocatedTo}})</span> </p>
        </div>
      </div>
      <div class="ticket-details" *ngIf="isExpanded && ticket">
        <app-ticket-details [ticket]="ticket" [user]="user" (updateIframe)="updateIframe()"></app-ticket-details>
      </div> 
    </div>
    <div class="flex expand col-xs-1" (click)="toggleExpand()">
      <span class="flex justifyFE mt-2">
        <mat-icon data-testid="ticket-expand" class="arrow-icon">{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </span>
    </div>
  </div>
  <div *ngIf="allocationView" class="flex justifyC">
    <div class="change-allocation-view">
      <div class="col-xs-12 flex icon-color justifyFE fontL4 fa fa-times" (click)="allocationView = false"></div>
      <div class="col-xs-12 justifyC flex gap-12" *ngIf="(userRoles.includes('adminDoctor') || userRoles.includes('admin'))">
        <label class="i-switch i-switch-sm" style="background-color: #10796C; margin: unset !important;">
          <input style="min-height: fit-content !important;" type="checkbox" [(ngModel)]="skipReAllocateDoctor" name="skipReAllocateDoctor"/><i></i>
        </label>
        <span class="underline" style="color: #10796C">skip reallocation</span>
      </div>
      <div class="flex flex-dir-col alignFS col-xs-12 justifyC" *ngIf="(userRoles.includes('adminDoctor') || userRoles.includes('admin'))">
        <label>Change Doctor</label>
        <div class="col-xs-12">
          <input-internal-user-select class="col-xs-12 pl-0" (onSelectInternalUser)="autoCompleteOnDoctorSelect($event)" [type]="apiClientConstant.User.Type.DOCTOR" ></input-internal-user-select>
        </div>
        <label style="margin: unset !important;" *ngIf="this.allocatedDoctor">{{getDoctorsDisplayName(this.allocatedDoctor)}}</label>
      </div>
      <div class="col-xs-12 flex justifyC pt-3">
        <button class="btn btn-xs btn-primary" (click)="assignTicket()">change allocation</button>
      </div>
    </div>
  </div>
</div>